import { Link } from "react-router-dom";

interface SiteCTAProps {
  title?: string;
  text?: string;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
}

export default function SiteCTA({
  title = "Çalışma planın dağınık kalmasın.",
  text = "Seviyeni seç, rotanı kur; her gün ne çalışacağını bil.",
  primaryLabel = "Rotanı Oluştur",
  primaryHref = "/siniflar",
  secondaryLabel = "Planları İncele",
  secondaryHref = "/paketler",
}: SiteCTAProps) {
  return (
    <section className="bg-primary-950 px-4 md:px-6 lg:px-10 py-16 md:py-24">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-background-50 leading-tight">
          {title}
        </h2>
        <p className="mt-4 text-base md:text-lg text-background-100/80 leading-relaxed max-w-xl mx-auto">
          {text}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to={primaryHref}
            className="w-full sm:w-auto whitespace-nowrap px-8 py-3.5 rounded-md text-base font-semibold bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-colors"
          >
            {primaryLabel}
          </Link>
          <Link
            to={secondaryHref}
            className="w-full sm:w-auto whitespace-nowrap px-8 py-3.5 rounded-md text-base font-semibold text-background-50 border border-background-50/30 hover:bg-background-50/10 transition-colors"
          >
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}